/** @jsx jsx */
import { jsx } from '@emotion/react';

import logger from 'js/app/loggerSingleton';

import RelatedSkillsComponent from 'bundles/page-config-common/components/shared/RelatedSkillsComponent';
import { usePageConfigComponentMetadata } from 'bundles/page-config-common/contexts/PageConfigComponentMetadataContext';
import { useRelatedSkills } from 'bundles/page-config-common/contexts/RelatedSkillsContext';
import type { PageConfig_BrowseRelatedSkillsComponentMetadataFragment as BrowseRelatedSkillsComponent } from 'bundles/page-config-common/queries/page-config/__generated__/PageConfig_CollectionComponentMetadata';

type Props = {
  pageConfig: BrowseRelatedSkillsComponent;
  disablePageTitleHeadingSize?: boolean;
};

const RelatedSkillsRenderer = (props: Props) => {
  const relatedSkillsContext = useRelatedSkills();
  const pageConfigComponentMetadataContext = usePageConfigComponentMetadata();

  if (!relatedSkillsContext) {
    logger.warn('RelatedSkillsRenderer expected RelatedSkillsProvider');
    return null;
  }
  if (!pageConfigComponentMetadataContext) {
    logger.warn('RelatedSkillsRenderer expected PageConfigComponentMetadataProvider');
    return null;
  }

  const {
    pageConfig: { sectionTitle: title },
    disablePageTitleHeadingSize = false,
  } = props;
  const { skills = [] } = relatedSkillsContext;
  const { index } = pageConfigComponentMetadataContext;

  if (skills.length === 0) {
    return null;
  }

  return (
    <RelatedSkillsComponent
      title={title}
      skills={skills}
      showPageTitleHeadingSize={!disablePageTitleHeadingSize && index === 0}
    />
  );
};

export default RelatedSkillsRenderer;
